import { Type } from 'typebox';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
import { SleepCheckDetail } from './sleep-check-detail.js';
export const SleepTypes = {
    overnight: 'overnight',
    nap: 'nap',
    unknown: 'unknown'
};
export const SleepType = Type.Union([
    Type.Literal(SleepTypes.overnight),
    Type.Literal(SleepTypes.nap),
    Type.Literal(SleepTypes.unknown)
]);
export const SleepTypeCodec = createFallbackStringEnumCodec(SleepTypes, SleepTypes.unknown);
export const NapEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.nap),
        startTime: Type.Optional(Type.Number()),
        endTime: Type.Optional(Type.Number()),
        checkDetails: Type.Optional(Type.Array(SleepCheckDetail)),
        sleepType: Type.Optional(SleepTypeCodec)
    })
]));
